module.exports = __webpack_public_path__ + "img/video-function.84983805.png";